import { useMutation } from 'query';
import { handleAxiosError } from 'ui';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { mediaUpload } from '../../services';

const defaultMutateOnError = (error: ApiClientResponseError<ResponseErrorDataObject>) => {
  handleAxiosError(error, 'Media cannot be uploaded, please try again later.');
};

export type MediaUploadParams = {
  file: File;
  ref: string;
  type: 'content_event_cover_photo' | 'content_reminder_cover_photo';
};

export const useMediaUpload = () =>
  useMutation<unknown, MediaUploadParams>({
    defaultMutateOnError,
    async mutationFn({ file, ref, type }) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('name', file.name);
      formData.append('ref', ref);
      formData.append('type', type);
      formData.append('mimeType', file.type);

      await mediaUpload({
        body: { formData },
      });
    },
  });
